export default class StatisticsPerCollection {
  valor!: number;

  total!: number;

  codColecao!: string;

  colecao!: string;
}
